import React from 'react'
import { FormikErrors } from 'formik'

import styles from './FieldError.module.scss'
import { Typography } from '@percent/lemonade'

export function FieldError(
  { error }: { error?: string | string[] | FormikErrors<any> | FormikErrors<any>[] } = {
    error: ''
  }
) {
  return (
    <Typography className={styles.fieldError} variant="small" $color="primary">
      <>&nbsp; {error}</>
    </Typography>
  )
}
